










































































































































































































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import BlurredTenant from '@/components/BlurredTenant.vue';
import { ChargingMembershipUsageDashboard } from "@/types/ChargingMembership";

export default Vue.extend({
    components: { BlurredTenant },
    data() {
        return {
            userManager,
            showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
            dashboardData: null as ChargingMembershipUsageDashboard | null,
            loading: false,
            error: null as string | null,
            filters: {
                userId: null,
            },
        };
    },
    async mounted() {
        this.initializeFiltersFromQuery();
        await this.loadDashboardData();
    },
    methods: {
        initializeFiltersFromQuery() {
            const { userId } = this.$route.query;
            if (userId) {
                this.filters.userId = userId;
            } else {
                // Use current user's ID if no userId in route
                this.filters.userId = userManager.getUserInfo()._id;
            }
        },

        async loadDashboardData() {
            this.loading = true;
            this.error = null;

            try {
                const id = this.filters.userId;

                this.dashboardData = await coreApiClient.callRaw("chargingMemberships", "getUsageDashboard", {
                    id
                });
            } catch (error) {
                this.error = (error as any).message || "Failed to load dashboard data";
                console.error("Dashboard load error:", error);
            } finally {
                this.loading = false;
            }
        },

        async refreshData() {
            await this.loadDashboardData();
        },


        formatCurrency(amount: number): string {
            return new Intl.NumberFormat('vi-VN', {
                style: 'currency',
                currency: 'VND'
            }).format(amount || 0);
        },

        formatDate(timestamp: number): string {
            return new Date(timestamp).toLocaleDateString("en-GB");
        },

        formatRecurrenceType(type: string): string {
            switch (type) {
                case "none":
                    return "No Recurrence";
                case "daily":
                    return "Daily";
                case "weekly":
                    return "Weekly";
                case "monthly":
                    return "Monthly";
                default:
                    return type || "Unknown";
            }
        },

        getRecurrenceColor(type: string): string {
            switch (type) {
                case "none":
                    return "grey";
                case "daily":
                    return "blue";
                case "weekly":
                    return "green";
                case "monthly":
                    return "purple";
                default:
                    return "grey";
            }
        },

        getProgressColor(percentage: number): string {
            if (percentage >= 90) {
                return "red";
            }
            if (percentage >= 75) {
                return "orange";
            }
            if (percentage >= 50) {
                return "yellow";
            }
            return "green";
        },
    },
});
